import { Typography } from '@iheartjane/reefer';
import { formatCurrency } from '@iheartjane/utils';

interface ProductCardPriceProps {
  discountPrice?: number;
  formattedPrice: string;
  hideStrikethroughPrice?: boolean;
  unitPrice?: number;
}

export const ProductCardPrice = ({
  unitPrice,
  discountPrice,
  hideStrikethroughPrice,
  formattedPrice,
}: ProductCardPriceProps) => {
  return (
    <>
      <Typography
        variant="body-bold"
        color={discountPrice ? 'sunset' : undefined}
        mr={8}
      >
        {formattedPrice}
      </Typography>
      {!!discountPrice &&
        unitPrice !== discountPrice &&
        !hideStrikethroughPrice && (
          <Typography color="grays-mid" variant="mini" strikeThrough mt="auto">
            {formatCurrency(unitPrice)}
          </Typography>
        )}
    </>
  );
};
